/**
 * フィルターのNull許容設定を保存・復元するためのマーカー文字列
 */
export const INCLUDE_NULL_MARKER = '__include_null__';
